export const WorkspaceConfig_DiseaseProfile = {
    name: 'Disease Profile',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'diseasePropertyPanel', visible: true, factor: 1 / 5, min: 200,
                data: {
                    filter: '',
                    selectedDiseaseProperty: undefined,
                }
            },
            {
                name: 'RightPanel', key: 'propertyDataPanel', visible: true, factor: 4 / 5, min: 800,
                data: {}
            },
        ]
    }
};
